export default __webpack_public_path__ + "assets/bg-heh.jpg";